// extracted by mini-css-extract-plugin
export default {"holder":"styles_holder__CbkzC","calendar":"styles_calendar__m+JuH","icon":"styles_icon__1-37g"};